import { useTranslation } from 'react-i18next';
// import { useUserContext } from '../../shared/tag/context/UserContext/useUserContext';
import styles from './UserInformation.module.scss';
import { USER_INFORMATION_TEST_ID } from '@application/modules/shared/dataTestId';

export type UserInformationProps = {
  firstName?: string | null;
  accountName?: string | null;
};

export const UserInformation = ({ firstName, accountName }: UserInformationProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.infoContainer} data-testid={USER_INFORMATION_TEST_ID}>
      <span className={styles.name}>
        <span role="img" aria-label="hand-wave">
          👋
        </span>
        {t('Welcome {{firstName}}!', { firstName })}
      </span>
      <span className={styles.account}>{t('Account: {{accountName}}', { accountName })}</span>
    </div>
  );
};
